import axios from "axios";
import { API } from "../../const";
import { normParam } from "../../tools";
const M_API = API + "/api";
// import { normParam } from '@/tools'
// import Vue from 'vue'

// const M_API = API + '/user'
const lc = window.localStorage;
const TOKEN = "siapbbjatimtoken";
const RTOKEN = "rToken";

const store = {
  namespaced: true,
  state: {
    user: null,
    config: null,
    token: lc.getItem(TOKEN),
    rToken: lc.getItem(RTOKEN),
    permission: [],
    roles: [],
    meta: null,
    promiseRT: null,
    arrayOfRT: [],
    retryRefresh: true
  },
  getters: {
    user(state) {
      return state.user;
    },
    permission(state) {
      return state.permission;
    },
    userMeta(state) {
      return state.meta ? state.meta.users_meta : null;
    },
    roles(state) {
      return state.roles;
    },
    check(state) {
      return state.token;
    },
    token(state) {
      return state.token;
    },
    rToken(state) {
      return state.rToken;
    },
    promiseRT(state) {
      return state.promiseRT;
    },
    arrayOfRT(state) {
      return state.arrayOfRT;
    },
    retryRefresh(state) {
      return state.retryRefresh;
    }
  },
  mutations: {
    addArrayRT(state, val) {
      state.arrayOfRT.push(val);
    },
    setPromiseRT(state, val) {
      state.promiseRT = val;
      state.promiseRT.then(() => {
        //jalankan function request ulang API
        var y = state.arrayOfRT.map(f => f());

        //setelah semua promise y dijalankan set null
        Promise.allSettled(y)
          .then(() => {
            state.promiseRT = null;
            state.arrayOfRT = [];
          })
          .catch(() => {
            state.promiseRT = null;
            state.arrayOfRT = [];
          });
      });
    },
    retryRefresh(state, val) {
      state.retryRefresh = val;
    },
    login(state, { user, token, rToken }) {
      let u = {
        ...user
      };
      delete u.token;

      state.user = user;
      state.token = token;
      state.rToken = rToken;
      lc.setItem(TOKEN, token);
      lc.setItem(RTOKEN, rToken);
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.rToken = null;
      state.instansi_aktif = null;
      // state.role = null
      state.roles = [];
      state.permission = [];
      state.promiseRT = null;
      state.arrayOfRT = [];
      state.retryRefresh = true;

      lc.removeItem(TOKEN);
      lc.removeItem(RTOKEN);
      // lc.removeItem(INSTANSI_AKTIF)
      // lc.removeItem(ROLE)
      // if (Vue.prototype.$Tawk) {
      //   Vue.prototype.$Tawk.$hideWidget()
      //   Vue.prototype.$Tawk.$endChat()
      // }
    },
    setToken(state, { token }) {
      state.token = token;
      lc.setItem(TOKEN, token);
    },
    setrToken(state, { rToken }) {
      state.rToken = rToken;
      lc.setItem(RTOKEN, rToken);
    },
    delToken(state) {
      state.token = null;
      lc.removeItem(TOKEN);
    }
  },
  actions: {
    // eslint-disable-next-line
    get({}, { params }) {
      return axios
        .get(`${M_API}/user${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    instansi({}, params) {
      return axios
        .get(`${M_API}/tenant${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    profil({ state }) {
      return axios
        .get(`${M_API}/profilku`)
        .then(res => {
          state.user = {
            ...res.data
          };
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    detail(_, user_id) {
      return axios.get(`${API}/users/${user_id}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    verify(_, token) {
      return axios.post(`${M_API}/verify`, token).then(res => {
        return res.data;
      });
    },
    link_password(_, data) {
      return axios.post(`${M_API}/link_password`, data).then(res => {
        return res.data;
      });
    },
    changePassword(_, data) {
      return axios.post(`${M_API}/self`, data).then(res => {
        return res.data;
      });
    },
    resetPassword(_, data) {
      return axios.post(`${M_API}/password`, data).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    // eslint-disable-next-line
    form({}, obj) {
      if (obj.id) {
        return axios
          .put(`${M_API}/user/${obj.id}`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      } else {
        return axios
          .post(`${M_API}/user`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      }
    },
    setGenerateAll(_, obj) {
      return axios
        .put(`${M_API}/user/${obj.id}/set_generate_all_kta`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    profil({}, obj) {
      if (obj.id) {
        let formData = new FormData();
        formData.append("id", obj.id);
        formData.append("name", obj.name);
        formData.append("email", obj.email);
        formData.append("no_hp", obj.no_hp);
        formData.append("kelamin", obj.kelamin);
        formData.append("_method", "put");
        if (obj.foto) {
          formData.append("foto", obj.foto);
        }
        return axios.post(`${API}/api/self`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      } else {
        let formData = new FormData();
        formData.append("id", obj.id);
        formData.append("name", obj.name);
        formData.append("email", obj.email);
        formData.append("no_hp", obj.no_hp);
        formData.append("kelamin", obj.kelamin);
        formData.append("role_id", obj.peran.id);
        if (obj.foto) {
          formData.append("foto", obj.foto);
        }
        return axios.post(`${API}/api/self`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      }
    },
    // eslint-disable-next-line
    register(_, obj) {
      return axios
        .post(`${M_API}/register`, obj)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios.delete(`${M_API}/user/${item.id}`).then(res => {
        return res.data;
      });
    },
    refreshToken(_, { grant_type, client_id, client_secret, refresh_token }) {
      return axios
        .post(`${API}/oauth/token`, {
          grant_type,
          client_id,
          client_secret,
          refresh_token
        })
        .then(res => {
          return res.data;
        });
    },
    saveToken({ dispatch, commit }, token) {
      commit("setToken", token);
      // try get me
      return dispatch("fetch").catch(() => {
        commit("delToken", null);
        return Promise.reject();
      });
    },
    // eslint-disable-next-line
    login(
      {
        commit,
        dispatch
        // state
      },
      { grant_type, client_id, client_secret, username, password }
    ) {
      // commit("login", {
      //   user: { email: "test@test.com", name: "Admin" },
      //   token:
      //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiNTFmMzcwMjVjYmJhOTViNDljMWQ1YTM4MDY0NDdjNmY2YjZmMGQ1ZGI2Zjk5MDY0NTNkOGIxYTE2Njk3OWYxZWZiNTA1ZmY2ODQ5MjUzODEiLCJpYXQiOjE2MDc2NjYxMjcsIm5iZiI6MTYwNzY2NjEyNywiZXhwIjoxNjA4OTYyMTI3LCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.H6BGSA4RTP7mKHUYBKlVig9bWEa1TS2PFizFSuWx4LNvGqd_BFQFc4qnPBv6treYH37atRHdrleHwSeqQ9tipNXJtpthfW-OVMtBM1fIHXjnraAmF_4t5yx-E2ML58KsFOjubALL95VeERX_4lVwU9z_y5zrGA-s-Ol8IRCFjvcA3L-09it9xqayjaIsGwOdJ0mQg2dELkZ1JbuPoAJ8gheACFlzkrsH-RVgcv3LX9CGwHNIPWvdH5QJan0bJrteSw6JNz26UdYaNSehUUz2kpXkZSVCltQ_x1Ks0SEWRBCNWd3qYCtaEfpAhfyIlTWjMdQYYYgIUCytZc6E-9lk90SSYo7lqn_SeBKJdzR7DwE51QSNNICwyjrQRPSg9Q7Gha56k690d6lZQATZ-j3S1lng50WlnEZ-wKH4n24uOz4KEi6-3so0pF2m93pvspI1JsqLaU5rB5hOcs8EBOgjYB8_Rbpjwbxvof3IWj-NbfJaiP9V5Qh8ru7wtXekNyOtifT6E_GmZsKsfS5tUnFksHZEQ9e8zQbbEqpknPlLv_1X9tiCDvkBGVLw2jyRGI3gW4rikQf2QIj2yTgJ8ZtwTtnBe4orQziVsXy5N14RmvZI7uaG9G_ftee5w3eKkZH4iEBWblPbWFCtmCY5RO1U9JxeY43fV-IPaET4tXcuDLE"
      // });
      // return Promise.resolve();

      return axios
        .post(`${API}/oauth/token`, {
          grant_type,
          client_id,
          client_secret,
          username,
          password
        })
        .then(res => {
          let token = res.data.access_token;
          let rToken = res.data.refresh_token;
          // state.token = token
          commit("login", {
            token,
            rToken
          });
          return dispatch("fetch");
        })
        .catch(err => {
          Promise.reject(err);
          return err;
        });
    },
    // eslint-disable-next-line
    logout({ commit }) {
      // return axios.get(`${BASE_API}/logout`)
      //   .then(() => {
      //     commit('logout')
      //   })
      commit("logout");
      return Promise.resolve();
    },
    fetchOne(_,{}){
      return axios.get(`${M_API}/self`).then(res => {
        state.user = {
          ...res.data,
          name: res.data.name
        };
      });
    },
    // eslint-disable-next-line
    fetch({
      state
      // dispatch
    }) {
      if (!state.token) return Promise.reject(null);
      else {
        if (state.user) {
          return Promise.resolve();
        } else {
          // state.user = {
          //   id: 1,
          //   name: "Super Admin",
          //   email: "admin@admin.com",
          //   no_hp: "null",
          //   kode_verifikasi: null,
          //   is_super_admin: 1,
          //   foto: null,
          //   upload_id: null,
          //   nip: null,
          //   kelamin: null,
          //   is_aktif: 1,
          //   deleted_at: null,
          //   alamat: null,
          //   tmp_lahir: null,
          //   tgl_lahir: null,
          //   peran: null,
          //   lingkup: {
          //     id: 1001,
          //     singkat: null,
          //     keterangan: "Kota Demo",
          //     propinsi_id: 10,
          //     tingkat: 3,
          //     latitude: -4.912965899999999663805283489637076854705810546875,
          //     longitude: 109.239520999999996320184436626732349395751953125
          //   }
          // };
          return axios.get(`${M_API}/self`).then(res => {
            state.user = {
              ...res.data,
              name: res.data.name
            };
          });
          // .then(() => {
          //   if (state.instansi_aktif)
          //     dispatch('getConfig')
          // })
        }
      }
    },
    // eslint-disable-next-line
    getRole({ state }) {
      return axios.get(`${API}/users/list-permissions`).then(res => {
        state.permission = res.data.data;
      });
    }
  }
};

export default store;
